export const AI_SESSION_FEEDBACK_REASONS = [
    "wrong_information",
    "did_not_understand",
    "cannot_do_what_i_need",
    "wanted_a_person",
    "too_slow",
];
export const AI_SESSION_FEEDBACK_REASON_MAX_RATING = 3;
